import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.image-slider').forEach((section) => {
        const sliderContainer = section.querySelector('.is-mainwrap.swiper');
        if (!sliderContainer) { return; }

        const autoplay = sliderContainer.dataset.autoplay === '1';

        new Swiper(sliderContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            speed: 700,

            effect: 'fade',
            fadeEffect: { crossFade: true },

            autoplay: autoplay ? { delay: 10000, disableOnInteraction: false } : false,

            navigation: {
                prevEl: section.querySelector('.arrow-prev'),
                nextEl: section.querySelector('.arrow-next'),
            },

            pagination: {
                el: section.querySelector('.is-pagination'),
                clickable: true,
            },

            keyboard: { enabled: true, onlyInViewport: true },
        });
    });
});
